export default {
  red: '#f44336',
  green: '#4caf50',
};
